import PropTypes from "prop-types";
import PaymentOptionImage from "../PaymentOptionImage";
import { PaymentOption } from "../../constants/PaymentOption";
import { cn } from "@helpers/general";
import data from "../../data/localized_payment_options.json";
import { ComponentType } from "../../constants/ComponentType";

function ALPaymentMethod({ locale, componentType, className }) {
  const hasOwnPaymentOptions = data.data.hasOwnProperty(locale);
  let paymentOptions;
  if (hasOwnPaymentOptions) {
    const currentLocalePaymentOptions = data.data[locale];
    paymentOptions = currentLocalePaymentOptions.map((paymentOption, index) => (
      <PaymentOptionImage payment={paymentOption} key={index} />
    ));
  }
  return (
    <div
      className={cn(
        "flex flex-row w-[80%] gap-[4px] relative my-[8px] mobile:my-[0px]",
        (ComponentType.PDP_ADS === componentType || ComponentType.PDP === componentType) &&
          "w-full max-w-[250px]",
        className
      )}
    >
      {hasOwnPaymentOptions ? (
        paymentOptions
      ) : (
        <>
          <PaymentOptionImage payment={PaymentOption.VISA} />
          <PaymentOptionImage payment={PaymentOption.AMAZON_PAY} />
          <PaymentOptionImage payment={PaymentOption.PAYPAL} />
          <PaymentOptionImage payment={PaymentOption.MASTERCARD} />
          <PaymentOptionImage payment={PaymentOption.DISCOVER} />
          <PaymentOptionImage payment={PaymentOption.AMERICAN_EXPRESS} />
        </>
      )}
    </div>
  );
}

ALPaymentMethod.propTypes = {
  locale: PropTypes.string.isRequired,
  componentType: PropTypes.string,
  className: PropTypes.string,
};

export default ALPaymentMethod;
